import React from "react";
import { Image } from "react-konva";
import useImage from "use-image";

const SignatureSigned = (props: any) => {
  const [image] = useImage(props.src);

  const scale = React.useMemo(() => {
    const imageWidth = image?.width ?? props.width;
    const imageHeight = image?.height ?? props.height;
    const imgHeightScale = props.height / imageHeight;
    const newWidth = imageWidth * imgHeightScale;

    return { width: newWidth, height: props.height, scaleY: imgHeightScale};
  }, [props.width, props.height, image]);

  return (
    <Image
      width={scale.width}
      height={scale.height}
      image={image}
      x={(props.width - scale.width) / 2}
      y={props.y}
      scale={props.scale}
      scaleX={props.scaleX}
      scaleY={props.scaleY}
    />
  );
};

export default SignatureSigned;
